import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";

export default function ErrorLogView() {
  const { apiFetch, t, dark, card, btnSm, userRole } = useApp();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await apiFetch("/api/error-log");
      const j = await r.json();
      setData(j);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { if (userRole === "admin") load(); }, [userRole]);

  if (userRole !== "admin") return <div style={{ padding: 24 }}>Доступ тільки для адмінів</div>;

  const resolve = async (id) => {
    await apiFetch(`/api/error-log/${id}/resolve`, { method: "POST" });
    load();
  };
  const purge = async (id) => {
    if (!window.confirm("Видалити запис?")) return;
    await apiFetch(`/api/error-log/${id}`, { method: "DELETE" });
    load();
  };

  return (
    <div style={{ padding: "16px 24px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>🐞 Error Log</h2>
        {data && (
          <span style={{ fontSize: 12, color: t.textMuted }}>
            {data.totals.distinct} уникальных / {data.totals.total} всего за 7 днів
          </span>
        )}
        <button onClick={load} disabled={loading} style={{ ...btnSm, marginLeft: "auto" }}>{loading ? "..." : "↻ Оновити"}</button>
      </div>

      {data?.errors?.length === 0 && <div style={{ ...card, padding: 24, textAlign: "center", color: t.textMuted }}>Немає помилок за останні 7 днів 🎉</div>}

      {data?.errors?.map(e => (
        <div key={e.id} style={{ ...card, padding: 14, marginBottom: 8, opacity: e.resolved ? 0.55 : 1 }}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 4 }}>
                <span style={{ fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 4, background: e.count > 50 ? "rgba(239,68,68,0.15)" : "rgba(245,158,11,0.15)", color: e.count > 50 ? "#ef4444" : "#f59e0b" }}>×{e.count}</span>
                {e.source && <span style={{ fontSize: 10, color: t.textMuted, fontFamily: "monospace" }}>{e.source}</span>}
                {e.resolved && <span style={{ fontSize: 10, color: "#10b981", fontWeight: 600 }}>✓ resolved</span>}
                <span style={{ marginLeft: "auto", fontSize: 10, color: t.textMuted }}>
                  Last: {new Date(e.last_seen).toLocaleString("uk-UA")}
                </span>
              </div>
              <div style={{ fontSize: 13, fontFamily: "monospace", wordBreak: "break-word", color: t.text, cursor: "pointer" }} onClick={() => setExpanded(expanded === e.id ? null : e.id)}>
                {e.message.length > 200 && expanded !== e.id ? e.message.slice(0, 200) + "..." : e.message}
              </div>
              {expanded === e.id && e.stack && (
                <pre style={{ fontSize: 11, color: t.textMuted, background: dark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.03)", padding: 8, borderRadius: 6, marginTop: 8, overflowX: "auto", whiteSpace: "pre-wrap" }}>{e.stack}</pre>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              {!e.resolved && <button onClick={() => resolve(e.id)} style={btnSm}>✓ Resolved</button>}
              <button onClick={() => purge(e.id)} style={{ ...btnSm, color: "#ef4444" }}>🗑</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
